import React from 'react';
import { AttributionTagStatus, STATUS_COLORS } from '@/types/attributionTag';
import { clsx } from 'clsx';

interface StatusBadgeProps {
  status: AttributionTagStatus;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const StatusBadge: React.FC<StatusBadgeProps> = ({
  status,
  size = 'sm',
  className
}) => {
  // Normalize legacy status values to new format
  const normalizeStatus = (s: string): AttributionTagStatus => {
    const normalized = s?.toLowerCase();
    if (normalized === 'active') return 'Active';
    if (normalized === 'inactive' || normalized === 'draft' || normalized === 'paused' || normalized === 'retired') return 'Inactive';
    return 'Active'; // Default fallback
  };

  const normalizedStatus = normalizeStatus(status);
  const colors = STATUS_COLORS[normalizedStatus];

  const sizeClasses = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-2.5 py-1 text-sm',
    lg: 'px-3 py-1.5 text-base',
  };

  const statusLabels: Record<AttributionTagStatus, string> = {
    Active: 'Active',
    Inactive: 'Inactive',
  };

  return (
    <span
      className={clsx(
        'inline-flex items-center font-medium rounded-full capitalize',
        colors.bg,
        colors.text,
        sizeClasses[size],
        className
      )}
    >
      {statusLabels[normalizedStatus]}
    </span>
  );
};

export default StatusBadge;
